module.exports = __webpack_public_path__ + "img/img10.34b30723.png";